export function deferred<T, E = Error>(): {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: E) => void;
} {
  let resolve: (value: T | PromiseLike<T>) => void;
  let reject: (reason?: E) => void;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  // The type assertions `resolve!` and `reject!` are safe here because
  // the Promise constructor calls the executor immediately, so they are
  // guaranteed to be assigned.
  return { promise, resolve: resolve!, reject: reject! };
}
